/**
 * Form Submitted event - tracks when users submit forms
 * This event follows the core.usertracking.FormSubmitted.v1 schema
 */

import { z } from 'zod';

import { defineEvent } from '../event-factory';

export default defineEvent({
  eventName: 'core.usertracking.FormSubmitted.v1',

  // What data this event needs (see schema link for full details)
  // https://app.make.rvohealth.com/schemas/sch_28caMFpIU5sa1tnjGYwflZwV07k
  cohesionSchema: {
    autofillUsed: z.boolean().optional(),
    correlationId: z.string().optional(),
    field: z
      .array(
        z.object({
          autofilled: z.boolean().optional(),
          fieldId: z.string().optional(),
          fieldLabel: z.string().optional(),
          fieldName: z.string().optional(),
          fieldType: z.string().optional(),
          fieldValue: z.string().optional(),
        }),
      )
      .optional(),
    formContext: z
      .object({
        formBrand: z.string().optional(),
        formId: z.string().optional(),
        formName: z.string().optional(),
        formType: z.string().optional(),
        formVersion: z.string().optional(),
      })
      .optional(),
    outboundUrl: z.string().optional(),
    stepContext: z
      .object({
        stepId: z.string().optional(),
        stepName: z.string().optional(),
        stepNumber: z.number().optional(),
        stepType: z
          .enum([
            'UNKNOWN',
            'SERVICEABILITY',
            'CONTACT',
            'PRODUCT',
            'CONFIRMATION',
            'CREDENTIALS',
            'PREFERENCE',
            'AUTHENTICATION',
          ])
          .optional(),
      })
      .optional(),
    customDimensions: z
      .array(
        z.object({
          key: z.string(),
          value: z.string(),
        }),
      )
      .optional(), // additional information about the event
  },
});
